const STORAGE_KEY = 'app-auth-pkce';

/**
 * One-shot sessionStorage slot for the PKCE verifier of the app's hosted-UI
 * login leg. Deliberately separate from @bettercomp/ams-spa-auth's verifier
 * store: the package key belongs to its own state-nonce-validated flow, while
 * this one backs the legacy-compatible leg where the verifier is optional
 * (see fetchAuthToken's conditional send).
 */
export const pkceVerifierStore = {
  put(verifier: string): void {
    sessionStorage.setItem(STORAGE_KEY, verifier);
  },
  /** Read-and-delete: a verifier must never survive the exchange attempt it was minted for. */
  take(): string | null {
    const verifier = sessionStorage.getItem(STORAGE_KEY);
    if (verifier !== null) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
    return verifier;
  },
  /**
   * Best-effort removal for login legs that end without an exchange (hosted-UI
   * ?error=... landings) — a leftover verifier would attach a stale
   * code_verifier to the next challenge-less code (e.g. IdP-initiated SSO in
   * this tab). Swallows storage failures: cleanup runs on error paths and must
   * never mask the error that led there.
   */
  clear(): void {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // Inaccessible storage also means no verifier could have been stored.
    }
  },
};
